/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Onboard_TeamInputs */



/**
* | output |
* | --- |
* | "How do I invite my team?" |
*
* @param {Uno_Welcome_Suggestion_Onboard_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_onboard_team = /** @type {((inputs?: Uno_Welcome_Suggestion_Onboard_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Onboard_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie lade ich mein Team ein?")
	return /** @type {LocalizedString} */ ("How do I invite my team?")
});